// Source: app/scripts/directives/multilingual-field.js
Auction.directive('multilingualField', ['crudService', function(crudService) {
    return {
        restrict: 'E',
        templateUrl: 'directives/multilingual-field.html',
        scope: {
            field: '@',
            required: '=',
            entity: '='
        }
    };
}]);
